import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Returns an imperative method for changing the location to previous page.
 */
const useNavigateToPrev = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasPreviousLocation = location.key !== 'default';

  return () => {
    if (hasPreviousLocation) navigate(-1);
    else navigate('/');
  };
};

export default useNavigateToPrev;
